// src/App.js
import React from 'react';
import './App.css'; // Main CSS for overall layout
import Header from './components/Header/Header';
import ProfessionalsValueProp from './components/Professionals Value Prop/Professionals Value Prop';
import ClientsValueProp from './components/Clients Value Prop/Clients Value Prop';
import KeyFeatures from './components/Key Features/Key Features';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ProfessionalsValueProp />
      <ClientsValueProp />
      <KeyFeatures />
      <Footer />
      
    </div>
  );
}

export default App;
